export default __webpack_public_path__ + "static/media/complete.07f2f9dd.svg";